import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Tools } from "@/types/agent-tools";
import { rag_v1 } from "@/utils/axios-v2";
import { useQuery } from "@tanstack/react-query";
import { BookOpenCheck, FolderOpen, Globe, Layers } from "lucide-react";
import { Tooltip } from "@/components/ui/tooltip-card";

import { AgentToolItem } from "./agent-tools-item";
import { useState } from "react";
import { cn } from "@/utils/cn";
import { Spinner } from "@/components/ui/spinner";
import { useTranslation } from "react-i18next";

export default function AgentToolsList({
  onOpen,
}: {
  onOpen?: (rect: DOMRect) => void;
}) {
  const { t } = useTranslation();
  const [openChange, setOpenChange] = useState(false);
  const toolsList = [
    {
      name: t("playground.listCollections"),
      icon: <Layers className="w-3 h-3" />,
    },
    {
      name: t("playground.retrieveFromCollection"),
      icon: <BookOpenCheck className="w-3 h-3" />,
    },
    {
      name: t("playground.webSearch"),
      icon: <Globe className="w-3 h-3" />,
    },
  ];
  const { data, isLoading } = useQuery<Tools>({
    queryKey: ["tools"],
    queryFn: () => rag_v1.get("agent-tools/tools/").then((data) => data.data),
  });

  if (onOpen) {
    return (
      <Tooltip content={t("playground.availableTools")}>
        <div
          onClick={(e) => onOpen(e.currentTarget.getBoundingClientRect())}
          className={cn(
            "transition-all p-2 cursor-pointer duration-150 rounded-[35px] hover:bg-secondary/50",
          )}
        >
          <FolderOpen className="text-foreground" />
        </div>
      </Tooltip>
    );
  }

  return (
    <DropdownMenu defaultOpen={openChange} onOpenChange={setOpenChange}>
      <DropdownMenuTrigger asChild>
        <div
          className={cn(
            "transition-all p-2  cursor-pointer duration-150 rounded-[35px] ",
            {
              "bg-secondary text-[var(--color-100)] transition-all duration-200":
                openChange,
            },
          )}
        >
          <FolderOpen className="text-foreground" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn("bg-[var(--card-background)] border-[1px] border-solid border-ring", {
          "flex justify-center h-12 items-center": isLoading,
        })}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          data?.map((tool, index) => (
            <AgentToolItem
              icon={toolsList[index].icon}
              id={tool.id}
              label={toolsList[index].name}
            />
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
